/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AterstallLosenordRouteImport } from './routes/aterstall-losenord'
import { Route as AviseringarRouteImport } from './routes/aviseringar'
import { Route as InbjudanRouteImport } from './routes/inbjudan'
import { Route as InstallningarRouteImport } from './routes/installningar'
import { Route as LoggaInRouteImport } from './routes/logga-in'
import { Route as OversiktRouteImport } from './routes/oversikt'
import { Route as BestallningarIndexRouteImport } from './routes/bestallningar.index'
import { Route as BestallningarOrderIdRouteImport } from './routes/bestallningar.$orderId'
import { Route as BestallningarHistorikRouteImport } from './routes/bestallningar.historik'
import { Route as ButikIndexRouteImport } from './routes/butik.index'
import { Route as ButikProductSlugRouteImport } from './routes/butik.$productSlug'
import { Route as ButikVarukorgRouteImport } from './routes/butik.varukorg'
import { Route as InstallningarIndexRouteImport } from './routes/installningar.index'
import { Route as InstallningarAviseringarRouteImport } from './routes/installningar.aviseringar'
import { Route as InstallningarBokningsreglerRouteImport } from './routes/installningar.bokningsregler'
import { Route as InstallningarIntegrationerRouteImport } from './routes/installningar.integrationer'
import { Route as InstallningarKalenderRouteImport } from './routes/installningar.kalender'
import { Route as InstallningarMobilRouteImport } from './routes/installningar.mobil'
import { Route as InstallningarOppettiderRouteImport } from './routes/installningar.oppettider'
import { Route as InstallningarPaminnelserRouteImport } from './routes/installningar.paminnelser'
import { Route as InstallningarPersonalRouteImport } from './routes/installningar.personal'
import { Route as InstallningarProfilRouteImport } from './routes/installningar.profil'
import { Route as InstallningarRapporterRouteImport } from './routes/installningar.rapporter'
import { Route as InstallningarTjansterRouteImport } from './routes/installningar.tjanster'
import { Route as NatverkIndexRouteImport } from './routes/natverk.index'
import { Route as NatverkNyRouteImport } from './routes/natverk.ny'
import { Route as ProdukterIndexRouteImport } from './routes/produkter.index'
import { Route as ProdukterProductIdRouteImport } from './routes/produkter.$productId'
import { Route as ProdukterInstallningarRouteImport } from './routes/produkter.installningar'
import { Route as ProdukterKategorierRouteImport } from './routes/produkter.kategorier'
import { Route as ButikBestallningarIndexRouteImport } from './routes/butik.bestallningar.index'
import { Route as ButikBestallningarOrderIdRouteImport } from './routes/butik.bestallningar.$orderId'
import { Route as InstallningarPersonalResourceIdRouteImport } from './routes/installningar.personal_.$resourceId'
import { Route as NatverkPlatsFranchiseIdRouteImport } from './routes/natverk.plats.$franchiseId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AterstallLosenordRoute = AterstallLosenordRouteImport.update({
  id: '/aterstall-losenord',
  path: '/aterstall-losenord',
  getParentRoute: () => rootRouteImport,
} as any)
const AviseringarRoute = AviseringarRouteImport.update({
  id: '/aviseringar',
  path: '/aviseringar',
  getParentRoute: () => rootRouteImport,
} as any)
const InbjudanRoute = InbjudanRouteImport.update({
  id: '/inbjudan',
  path: '/inbjudan',
  getParentRoute: () => rootRouteImport,
} as any)
const InstallningarRoute = InstallningarRouteImport.update({
  id: '/installningar',
  path: '/installningar',
  getParentRoute: () => rootRouteImport,
} as any)
const LoggaInRoute = LoggaInRouteImport.update({
  id: '/logga-in',
  path: '/logga-in',
  getParentRoute: () => rootRouteImport,
} as any)
const OversiktRoute = OversiktRouteImport.update({
  id: '/oversikt',
  path: '/oversikt',
  getParentRoute: () => rootRouteImport,
} as any)
const BestallningarIndexRoute = BestallningarIndexRouteImport.update({
  id: '/bestallningar/',
  path: '/bestallningar/',
  getParentRoute: () => rootRouteImport,
} as any)
const BestallningarOrderIdRoute = BestallningarOrderIdRouteImport.update({
  id: '/bestallningar/$orderId',
  path: '/bestallningar/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const BestallningarHistorikRoute = BestallningarHistorikRouteImport.update({
  id: '/bestallningar/historik',
  path: '/bestallningar/historik',
  getParentRoute: () => rootRouteImport,
} as any)
const ButikIndexRoute = ButikIndexRouteImport.update({
  id: '/butik/',
  path: '/butik/',
  getParentRoute: () => rootRouteImport,
} as any)
const ButikProductSlugRoute = ButikProductSlugRouteImport.update({
  id: '/butik/$productSlug',
  path: '/butik/$productSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const ButikVarukorgRoute = ButikVarukorgRouteImport.update({
  id: '/butik/varukorg',
  path: '/butik/varukorg',
  getParentRoute: () => rootRouteImport,
} as any)
const InstallningarIndexRoute = InstallningarIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InstallningarRoute,
} as any)
const InstallningarAviseringarRoute =
  InstallningarAviseringarRouteImport.update({
    id: '/aviseringar',
    path: '/aviseringar',
    getParentRoute: () => InstallningarRoute,
  } as any)
const InstallningarBokningsreglerRoute =
  InstallningarBokningsreglerRouteImport.update({
    id: '/bokningsregler',
    path: '/bokningsregler',
    getParentRoute: () => InstallningarRoute,
  } as any)
const InstallningarIntegrationerRoute =
  InstallningarIntegrationerRouteImport.update({
    id: '/integrationer',
    path: '/integrationer',
    getParentRoute: () => InstallningarRoute,
  } as any)
const InstallningarKalenderRoute = InstallningarKalenderRouteImport.update({
  id: '/kalender',
  path: '/kalender',
  getParentRoute: () => InstallningarRoute,
} as any)
const InstallningarMobilRoute = InstallningarMobilRouteImport.update({
  id: '/mobil',
  path: '/mobil',
  getParentRoute: () => InstallningarRoute,
} as any)
const InstallningarOppettiderRoute = InstallningarOppettiderRouteImport.update({
  id: '/oppettider',
  path: '/oppettider',
  getParentRoute: () => InstallningarRoute,
} as any)
const InstallningarPaminnelserRoute =
  InstallningarPaminnelserRouteImport.update({
    id: '/paminnelser',
    path: '/paminnelser',
    getParentRoute: () => InstallningarRoute,
  } as any)
const InstallningarPersonalRoute = InstallningarPersonalRouteImport.update({
  id: '/personal',
  path: '/personal',
  getParentRoute: () => InstallningarRoute,
} as any)
const InstallningarProfilRoute = InstallningarProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => InstallningarRoute,
} as any)
const InstallningarRapporterRoute = InstallningarRapporterRouteImport.update({
  id: '/rapporter',
  path: '/rapporter',
  getParentRoute: () => InstallningarRoute,
} as any)
const InstallningarTjansterRoute = InstallningarTjansterRouteImport.update({
  id: '/tjanster',
  path: '/tjanster',
  getParentRoute: () => InstallningarRoute,
} as any)
const NatverkIndexRoute = NatverkIndexRouteImport.update({
  id: '/natverk/',
  path: '/natverk/',
  getParentRoute: () => rootRouteImport,
} as any)
const NatverkNyRoute = NatverkNyRouteImport.update({
  id: '/natverk/ny',
  path: '/natverk/ny',
  getParentRoute: () => rootRouteImport,
} as any)
const ProdukterIndexRoute = ProdukterIndexRouteImport.update({
  id: '/produkter/',
  path: '/produkter/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProdukterProductIdRoute = ProdukterProductIdRouteImport.update({
  id: '/produkter/$productId',
  path: '/produkter/$productId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProdukterInstallningarRoute = ProdukterInstallningarRouteImport.update({
  id: '/produkter/installningar',
  path: '/produkter/installningar',
  getParentRoute: () => rootRouteImport,
} as any)
const ProdukterKategorierRoute = ProdukterKategorierRouteImport.update({
  id: '/produkter/kategorier',
  path: '/produkter/kategorier',
  getParentRoute: () => rootRouteImport,
} as any)
const ButikBestallningarIndexRoute = ButikBestallningarIndexRouteImport.update({
  id: '/butik/bestallningar/',
  path: '/butik/bestallningar/',
  getParentRoute: () => rootRouteImport,
} as any)
const ButikBestallningarOrderIdRoute =
  ButikBestallningarOrderIdRouteImport.update({
    id: '/butik/bestallningar/$orderId',
    path: '/butik/bestallningar/$orderId',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallningarPersonalResourceIdRoute =
  InstallningarPersonalResourceIdRouteImport.update({
    id: '/personal_/$resourceId',
    path: '/personal/$resourceId',
    getParentRoute: () => InstallningarRoute,
  } as any)
const NatverkPlatsFranchiseIdRoute = NatverkPlatsFranchiseIdRouteImport.update({
  id: '/natverk/plats/$franchiseId',
  path: '/natverk/plats/$franchiseId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/aterstall-losenord': typeof AterstallLosenordRoute
  '/aviseringar': typeof AviseringarRoute
  '/inbjudan': typeof InbjudanRoute
  '/installningar': typeof InstallningarRouteWithChildren
  '/logga-in': typeof LoggaInRoute
  '/oversikt': typeof OversiktRoute
  '/bestallningar/$orderId': typeof BestallningarOrderIdRoute
  '/bestallningar/historik': typeof BestallningarHistorikRoute
  '/butik/$productSlug': typeof ButikProductSlugRoute
  '/butik/varukorg': typeof ButikVarukorgRoute
  '/installningar/aviseringar': typeof InstallningarAviseringarRoute
  '/installningar/bokningsregler': typeof InstallningarBokningsreglerRoute
  '/installningar/integrationer': typeof InstallningarIntegrationerRoute
  '/installningar/kalender': typeof InstallningarKalenderRoute
  '/installningar/mobil': typeof InstallningarMobilRoute
  '/installningar/oppettider': typeof InstallningarOppettiderRoute
  '/installningar/paminnelser': typeof InstallningarPaminnelserRoute
  '/installningar/personal': typeof InstallningarPersonalRoute
  '/installningar/profil': typeof InstallningarProfilRoute
  '/installningar/rapporter': typeof InstallningarRapporterRoute
  '/installningar/tjanster': typeof InstallningarTjansterRoute
  '/natverk/ny': typeof NatverkNyRoute
  '/produkter/$productId': typeof ProdukterProductIdRoute
  '/produkter/installningar': typeof ProdukterInstallningarRoute
  '/produkter/kategorier': typeof ProdukterKategorierRoute
  '/bestallningar/': typeof BestallningarIndexRoute
  '/butik/': typeof ButikIndexRoute
  '/installningar/': typeof InstallningarIndexRoute
  '/natverk/': typeof NatverkIndexRoute
  '/produkter/': typeof ProdukterIndexRoute
  '/butik/bestallningar/$orderId': typeof ButikBestallningarOrderIdRoute
  '/installningar/personal/$resourceId': typeof InstallningarPersonalResourceIdRoute
  '/natverk/plats/$franchiseId': typeof NatverkPlatsFranchiseIdRoute
  '/butik/bestallningar/': typeof ButikBestallningarIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/aterstall-losenord': typeof AterstallLosenordRoute
  '/aviseringar': typeof AviseringarRoute
  '/inbjudan': typeof InbjudanRoute
  '/logga-in': typeof LoggaInRoute
  '/oversikt': typeof OversiktRoute
  '/bestallningar/$orderId': typeof BestallningarOrderIdRoute
  '/bestallningar/historik': typeof BestallningarHistorikRoute
  '/butik/$productSlug': typeof ButikProductSlugRoute
  '/butik/varukorg': typeof ButikVarukorgRoute
  '/installningar/aviseringar': typeof InstallningarAviseringarRoute
  '/installningar/bokningsregler': typeof InstallningarBokningsreglerRoute
  '/installningar/integrationer': typeof InstallningarIntegrationerRoute
  '/installningar/kalender': typeof InstallningarKalenderRoute
  '/installningar/mobil': typeof InstallningarMobilRoute
  '/installningar/oppettider': typeof InstallningarOppettiderRoute
  '/installningar/paminnelser': typeof InstallningarPaminnelserRoute
  '/installningar/personal': typeof InstallningarPersonalRoute
  '/installningar/profil': typeof InstallningarProfilRoute
  '/installningar/rapporter': typeof InstallningarRapporterRoute
  '/installningar/tjanster': typeof InstallningarTjansterRoute
  '/natverk/ny': typeof NatverkNyRoute
  '/produkter/$productId': typeof ProdukterProductIdRoute
  '/produkter/installningar': typeof ProdukterInstallningarRoute
  '/produkter/kategorier': typeof ProdukterKategorierRoute
  '/bestallningar': typeof BestallningarIndexRoute
  '/butik': typeof ButikIndexRoute
  '/installningar': typeof InstallningarIndexRoute
  '/natverk': typeof NatverkIndexRoute
  '/produkter': typeof ProdukterIndexRoute
  '/butik/bestallningar/$orderId': typeof ButikBestallningarOrderIdRoute
  '/installningar/personal/$resourceId': typeof InstallningarPersonalResourceIdRoute
  '/natverk/plats/$franchiseId': typeof NatverkPlatsFranchiseIdRoute
  '/butik/bestallningar': typeof ButikBestallningarIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/aterstall-losenord': typeof AterstallLosenordRoute
  '/aviseringar': typeof AviseringarRoute
  '/inbjudan': typeof InbjudanRoute
  '/installningar': typeof InstallningarRouteWithChildren
  '/logga-in': typeof LoggaInRoute
  '/oversikt': typeof OversiktRoute
  '/bestallningar/$orderId': typeof BestallningarOrderIdRoute
  '/bestallningar/historik': typeof BestallningarHistorikRoute
  '/butik/$productSlug': typeof ButikProductSlugRoute
  '/butik/varukorg': typeof ButikVarukorgRoute
  '/installningar/aviseringar': typeof InstallningarAviseringarRoute
  '/installningar/bokningsregler': typeof InstallningarBokningsreglerRoute
  '/installningar/integrationer': typeof InstallningarIntegrationerRoute
  '/installningar/kalender': typeof InstallningarKalenderRoute
  '/installningar/mobil': typeof InstallningarMobilRoute
  '/installningar/oppettider': typeof InstallningarOppettiderRoute
  '/installningar/paminnelser': typeof InstallningarPaminnelserRoute
  '/installningar/personal': typeof InstallningarPersonalRoute
  '/installningar/profil': typeof InstallningarProfilRoute
  '/installningar/rapporter': typeof InstallningarRapporterRoute
  '/installningar/tjanster': typeof InstallningarTjansterRoute
  '/natverk/ny': typeof NatverkNyRoute
  '/produkter/$productId': typeof ProdukterProductIdRoute
  '/produkter/installningar': typeof ProdukterInstallningarRoute
  '/produkter/kategorier': typeof ProdukterKategorierRoute
  '/bestallningar/': typeof BestallningarIndexRoute
  '/butik/': typeof ButikIndexRoute
  '/installningar/': typeof InstallningarIndexRoute
  '/natverk/': typeof NatverkIndexRoute
  '/produkter/': typeof ProdukterIndexRoute
  '/butik/bestallningar/$orderId': typeof ButikBestallningarOrderIdRoute
  '/installningar/personal_/$resourceId': typeof InstallningarPersonalResourceIdRoute
  '/natverk/plats/$franchiseId': typeof NatverkPlatsFranchiseIdRoute
  '/butik/bestallningar/': typeof ButikBestallningarIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/aterstall-losenord'
    | '/aviseringar'
    | '/inbjudan'
    | '/installningar'
    | '/logga-in'
    | '/oversikt'
    | '/bestallningar/$orderId'
    | '/bestallningar/historik'
    | '/butik/$productSlug'
    | '/butik/varukorg'
    | '/installningar/aviseringar'
    | '/installningar/bokningsregler'
    | '/installningar/integrationer'
    | '/installningar/kalender'
    | '/installningar/mobil'
    | '/installningar/oppettider'
    | '/installningar/paminnelser'
    | '/installningar/personal'
    | '/installningar/profil'
    | '/installningar/rapporter'
    | '/installningar/tjanster'
    | '/natverk/ny'
    | '/produkter/$productId'
    | '/produkter/installningar'
    | '/produkter/kategorier'
    | '/bestallningar/'
    | '/butik/'
    | '/installningar/'
    | '/natverk/'
    | '/produkter/'
    | '/butik/bestallningar/$orderId'
    | '/installningar/personal/$resourceId'
    | '/natverk/plats/$franchiseId'
    | '/butik/bestallningar/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/aterstall-losenord'
    | '/aviseringar'
    | '/inbjudan'
    | '/logga-in'
    | '/oversikt'
    | '/bestallningar/$orderId'
    | '/bestallningar/historik'
    | '/butik/$productSlug'
    | '/butik/varukorg'
    | '/installningar/aviseringar'
    | '/installningar/bokningsregler'
    | '/installningar/integrationer'
    | '/installningar/kalender'
    | '/installningar/mobil'
    | '/installningar/oppettider'
    | '/installningar/paminnelser'
    | '/installningar/personal'
    | '/installningar/profil'
    | '/installningar/rapporter'
    | '/installningar/tjanster'
    | '/natverk/ny'
    | '/produkter/$productId'
    | '/produkter/installningar'
    | '/produkter/kategorier'
    | '/bestallningar'
    | '/butik'
    | '/installningar'
    | '/natverk'
    | '/produkter'
    | '/butik/bestallningar/$orderId'
    | '/installningar/personal/$resourceId'
    | '/natverk/plats/$franchiseId'
    | '/butik/bestallningar'
  id:
    | '__root__'
    | '/'
    | '/aterstall-losenord'
    | '/aviseringar'
    | '/inbjudan'
    | '/installningar'
    | '/logga-in'
    | '/oversikt'
    | '/bestallningar/$orderId'
    | '/bestallningar/historik'
    | '/butik/$productSlug'
    | '/butik/varukorg'
    | '/installningar/aviseringar'
    | '/installningar/bokningsregler'
    | '/installningar/integrationer'
    | '/installningar/kalender'
    | '/installningar/mobil'
    | '/installningar/oppettider'
    | '/installningar/paminnelser'
    | '/installningar/personal'
    | '/installningar/profil'
    | '/installningar/rapporter'
    | '/installningar/tjanster'
    | '/natverk/ny'
    | '/produkter/$productId'
    | '/produkter/installningar'
    | '/produkter/kategorier'
    | '/bestallningar/'
    | '/butik/'
    | '/installningar/'
    | '/natverk/'
    | '/produkter/'
    | '/butik/bestallningar/$orderId'
    | '/installningar/personal_/$resourceId'
    | '/natverk/plats/$franchiseId'
    | '/butik/bestallningar/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AterstallLosenordRoute: typeof AterstallLosenordRoute
  AviseringarRoute: typeof AviseringarRoute
  InbjudanRoute: typeof InbjudanRoute
  InstallningarRoute: typeof InstallningarRouteWithChildren
  LoggaInRoute: typeof LoggaInRoute
  OversiktRoute: typeof OversiktRoute
  BestallningarOrderIdRoute: typeof BestallningarOrderIdRoute
  BestallningarHistorikRoute: typeof BestallningarHistorikRoute
  ButikProductSlugRoute: typeof ButikProductSlugRoute
  ButikVarukorgRoute: typeof ButikVarukorgRoute
  NatverkNyRoute: typeof NatverkNyRoute
  ProdukterProductIdRoute: typeof ProdukterProductIdRoute
  ProdukterInstallningarRoute: typeof ProdukterInstallningarRoute
  ProdukterKategorierRoute: typeof ProdukterKategorierRoute
  BestallningarIndexRoute: typeof BestallningarIndexRoute
  ButikIndexRoute: typeof ButikIndexRoute
  NatverkIndexRoute: typeof NatverkIndexRoute
  ProdukterIndexRoute: typeof ProdukterIndexRoute
  ButikBestallningarOrderIdRoute: typeof ButikBestallningarOrderIdRoute
  NatverkPlatsFranchiseIdRoute: typeof NatverkPlatsFranchiseIdRoute
  ButikBestallningarIndexRoute: typeof ButikBestallningarIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aterstall-losenord': {
      id: '/aterstall-losenord'
      path: '/aterstall-losenord'
      fullPath: '/aterstall-losenord'
      preLoaderRoute: typeof AterstallLosenordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aviseringar': {
      id: '/aviseringar'
      path: '/aviseringar'
      fullPath: '/aviseringar'
      preLoaderRoute: typeof AviseringarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbjudan': {
      id: '/inbjudan'
      path: '/inbjudan'
      fullPath: '/inbjudan'
      preLoaderRoute: typeof InbjudanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installningar': {
      id: '/installningar'
      path: '/installningar'
      fullPath: '/installningar'
      preLoaderRoute: typeof InstallningarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logga-in': {
      id: '/logga-in'
      path: '/logga-in'
      fullPath: '/logga-in'
      preLoaderRoute: typeof LoggaInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oversikt': {
      id: '/oversikt'
      path: '/oversikt'
      fullPath: '/oversikt'
      preLoaderRoute: typeof OversiktRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bestallningar/': {
      id: '/bestallningar/'
      path: '/bestallningar'
      fullPath: '/bestallningar/'
      preLoaderRoute: typeof BestallningarIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bestallningar/$orderId': {
      id: '/bestallningar/$orderId'
      path: '/bestallningar/$orderId'
      fullPath: '/bestallningar/$orderId'
      preLoaderRoute: typeof BestallningarOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bestallningar/historik': {
      id: '/bestallningar/historik'
      path: '/bestallningar/historik'
      fullPath: '/bestallningar/historik'
      preLoaderRoute: typeof BestallningarHistorikRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/butik/': {
      id: '/butik/'
      path: '/butik'
      fullPath: '/butik/'
      preLoaderRoute: typeof ButikIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/butik/$productSlug': {
      id: '/butik/$productSlug'
      path: '/butik/$productSlug'
      fullPath: '/butik/$productSlug'
      preLoaderRoute: typeof ButikProductSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/butik/varukorg': {
      id: '/butik/varukorg'
      path: '/butik/varukorg'
      fullPath: '/butik/varukorg'
      preLoaderRoute: typeof ButikVarukorgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installningar/': {
      id: '/installningar/'
      path: '/'
      fullPath: '/installningar/'
      preLoaderRoute: typeof InstallningarIndexRouteImport
      parentRoute: typeof InstallningarRoute
    }
    '/installningar/aviseringar': {
      id: '/installningar/aviseringar'
      path: '/aviseringar'
      fullPath: '/installningar/aviseringar'
      preLoaderRoute: typeof InstallningarAviseringarRouteImport
      parentRoute: typeof InstallningarRoute
    }
    '/installningar/bokningsregler': {
      id: '/installningar/bokningsregler'
      path: '/bokningsregler'
      fullPath: '/installningar/bokningsregler'
      preLoaderRoute: typeof InstallningarBokningsreglerRouteImport
      parentRoute: typeof InstallningarRoute
    }
    '/installningar/integrationer': {
      id: '/installningar/integrationer'
      path: '/integrationer'
      fullPath: '/installningar/integrationer'
      preLoaderRoute: typeof InstallningarIntegrationerRouteImport
      parentRoute: typeof InstallningarRoute
    }
    '/installningar/kalender': {
      id: '/installningar/kalender'
      path: '/kalender'
      fullPath: '/installningar/kalender'
      preLoaderRoute: typeof InstallningarKalenderRouteImport
      parentRoute: typeof InstallningarRoute
    }
    '/installningar/mobil': {
      id: '/installningar/mobil'
      path: '/mobil'
      fullPath: '/installningar/mobil'
      preLoaderRoute: typeof InstallningarMobilRouteImport
      parentRoute: typeof InstallningarRoute
    }
    '/installningar/oppettider': {
      id: '/installningar/oppettider'
      path: '/oppettider'
      fullPath: '/installningar/oppettider'
      preLoaderRoute: typeof InstallningarOppettiderRouteImport
      parentRoute: typeof InstallningarRoute
    }
    '/installningar/paminnelser': {
      id: '/installningar/paminnelser'
      path: '/paminnelser'
      fullPath: '/installningar/paminnelser'
      preLoaderRoute: typeof InstallningarPaminnelserRouteImport
      parentRoute: typeof InstallningarRoute
    }
    '/installningar/personal': {
      id: '/installningar/personal'
      path: '/personal'
      fullPath: '/installningar/personal'
      preLoaderRoute: typeof InstallningarPersonalRouteImport
      parentRoute: typeof InstallningarRoute
    }
    '/installningar/profil': {
      id: '/installningar/profil'
      path: '/profil'
      fullPath: '/installningar/profil'
      preLoaderRoute: typeof InstallningarProfilRouteImport
      parentRoute: typeof InstallningarRoute
    }
    '/installningar/rapporter': {
      id: '/installningar/rapporter'
      path: '/rapporter'
      fullPath: '/installningar/rapporter'
      preLoaderRoute: typeof InstallningarRapporterRouteImport
      parentRoute: typeof InstallningarRoute
    }
    '/installningar/tjanster': {
      id: '/installningar/tjanster'
      path: '/tjanster'
      fullPath: '/installningar/tjanster'
      preLoaderRoute: typeof InstallningarTjansterRouteImport
      parentRoute: typeof InstallningarRoute
    }
    '/natverk/': {
      id: '/natverk/'
      path: '/natverk'
      fullPath: '/natverk/'
      preLoaderRoute: typeof NatverkIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/natverk/ny': {
      id: '/natverk/ny'
      path: '/natverk/ny'
      fullPath: '/natverk/ny'
      preLoaderRoute: typeof NatverkNyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/produkter/': {
      id: '/produkter/'
      path: '/produkter'
      fullPath: '/produkter/'
      preLoaderRoute: typeof ProdukterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/produkter/$productId': {
      id: '/produkter/$productId'
      path: '/produkter/$productId'
      fullPath: '/produkter/$productId'
      preLoaderRoute: typeof ProdukterProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/produkter/installningar': {
      id: '/produkter/installningar'
      path: '/produkter/installningar'
      fullPath: '/produkter/installningar'
      preLoaderRoute: typeof ProdukterInstallningarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/produkter/kategorier': {
      id: '/produkter/kategorier'
      path: '/produkter/kategorier'
      fullPath: '/produkter/kategorier'
      preLoaderRoute: typeof ProdukterKategorierRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/butik/bestallningar/': {
      id: '/butik/bestallningar/'
      path: '/butik/bestallningar'
      fullPath: '/butik/bestallningar/'
      preLoaderRoute: typeof ButikBestallningarIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/butik/bestallningar/$orderId': {
      id: '/butik/bestallningar/$orderId'
      path: '/butik/bestallningar/$orderId'
      fullPath: '/butik/bestallningar/$orderId'
      preLoaderRoute: typeof ButikBestallningarOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installningar/personal_/$resourceId': {
      id: '/installningar/personal_/$resourceId'
      path: '/personal/$resourceId'
      fullPath: '/installningar/personal/$resourceId'
      preLoaderRoute: typeof InstallningarPersonalResourceIdRouteImport
      parentRoute: typeof InstallningarRoute
    }
    '/natverk/plats/$franchiseId': {
      id: '/natverk/plats/$franchiseId'
      path: '/natverk/plats/$franchiseId'
      fullPath: '/natverk/plats/$franchiseId'
      preLoaderRoute: typeof NatverkPlatsFranchiseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface InstallningarRouteChildren {
  InstallningarAviseringarRoute: typeof InstallningarAviseringarRoute
  InstallningarBokningsreglerRoute: typeof InstallningarBokningsreglerRoute
  InstallningarIntegrationerRoute: typeof InstallningarIntegrationerRoute
  InstallningarKalenderRoute: typeof InstallningarKalenderRoute
  InstallningarMobilRoute: typeof InstallningarMobilRoute
  InstallningarOppettiderRoute: typeof InstallningarOppettiderRoute
  InstallningarPaminnelserRoute: typeof InstallningarPaminnelserRoute
  InstallningarPersonalRoute: typeof InstallningarPersonalRoute
  InstallningarProfilRoute: typeof InstallningarProfilRoute
  InstallningarRapporterRoute: typeof InstallningarRapporterRoute
  InstallningarTjansterRoute: typeof InstallningarTjansterRoute
  InstallningarIndexRoute: typeof InstallningarIndexRoute
  InstallningarPersonalResourceIdRoute: typeof InstallningarPersonalResourceIdRoute
}

const InstallningarRouteChildren: InstallningarRouteChildren = {
  InstallningarAviseringarRoute: InstallningarAviseringarRoute,
  InstallningarBokningsreglerRoute: InstallningarBokningsreglerRoute,
  InstallningarIntegrationerRoute: InstallningarIntegrationerRoute,
  InstallningarKalenderRoute: InstallningarKalenderRoute,
  InstallningarMobilRoute: InstallningarMobilRoute,
  InstallningarOppettiderRoute: InstallningarOppettiderRoute,
  InstallningarPaminnelserRoute: InstallningarPaminnelserRoute,
  InstallningarPersonalRoute: InstallningarPersonalRoute,
  InstallningarProfilRoute: InstallningarProfilRoute,
  InstallningarRapporterRoute: InstallningarRapporterRoute,
  InstallningarTjansterRoute: InstallningarTjansterRoute,
  InstallningarIndexRoute: InstallningarIndexRoute,
  InstallningarPersonalResourceIdRoute: InstallningarPersonalResourceIdRoute,
}

const InstallningarRouteWithChildren = InstallningarRoute._addFileChildren(
  InstallningarRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AterstallLosenordRoute: AterstallLosenordRoute,
  AviseringarRoute: AviseringarRoute,
  InbjudanRoute: InbjudanRoute,
  InstallningarRoute: InstallningarRouteWithChildren,
  LoggaInRoute: LoggaInRoute,
  OversiktRoute: OversiktRoute,
  BestallningarOrderIdRoute: BestallningarOrderIdRoute,
  BestallningarHistorikRoute: BestallningarHistorikRoute,
  ButikProductSlugRoute: ButikProductSlugRoute,
  ButikVarukorgRoute: ButikVarukorgRoute,
  NatverkNyRoute: NatverkNyRoute,
  ProdukterProductIdRoute: ProdukterProductIdRoute,
  ProdukterInstallningarRoute: ProdukterInstallningarRoute,
  ProdukterKategorierRoute: ProdukterKategorierRoute,
  BestallningarIndexRoute: BestallningarIndexRoute,
  ButikIndexRoute: ButikIndexRoute,
  NatverkIndexRoute: NatverkIndexRoute,
  ProdukterIndexRoute: ProdukterIndexRoute,
  ButikBestallningarOrderIdRoute: ButikBestallningarOrderIdRoute,
  NatverkPlatsFranchiseIdRoute: NatverkPlatsFranchiseIdRoute,
  ButikBestallningarIndexRoute: ButikBestallningarIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
